export const getCsrfToken = (
  cookie = typeof document === 'undefined' ? '' : document.cookie
) => {
  const entry = String(cookie || '')
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith('csrftoken='));
  return entry ? decodeURIComponent(entry.slice('csrftoken='.length)) : '';
};

export const sessionRequestConfig = (csrfToken = getCsrfToken()) => ({
  withCredentials: true,
  headers: { 'X-CSRFToken': csrfToken },
});

export const ensureCsrfToken = async (apiUrl, getRequest) => {
  const cookieToken = getCsrfToken();
  if (cookieToken) return cookieToken;

  if (typeof getRequest !== 'function') {
    const error = new Error('No se configuró la inicialización CSRF.');
    error.code = 'CSRF_TOKEN_MISSING';
    throw error;
  }

  const response = await getRequest(`${apiUrl}/csrf/`, { withCredentials: true });
  const initializedToken = getCsrfToken() || response?.data?.csrfToken || '';
  if (!initializedToken) {
    const error = new Error('No fue posible inicializar la protección CSRF.');
    error.code = 'CSRF_TOKEN_MISSING';
    throw error;
  }
  return initializedToken;
};

export const authenticatedSessionRequestConfig = async (apiUrl, getRequest) => (
  sessionRequestConfig(await ensureCsrfToken(apiUrl, getRequest))
);
